import { render, staticRenderFns } from "./InvoicesID.vue?vue&type=template&id=0d0dfd94&"
import script from "./InvoicesID.vue?vue&type=script&lang=js&"
export * from "./InvoicesID.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports